import { WorkflowStepInterface } from '@vendasta/automata';
import {
  Branch,
  BRANCH_OPTIONS,
  NO_CONDITIONS_MET,
  NONE,
  RIGHT,
  USE_DYNAMIC_BRANCH_LABEL,
} from './component-loader/branch-options';

export class BranchUtilities {
  static getBranchClass(step: WorkflowStepInterface, branch: Branch): string {
    let classKey = 'yes-node';
    if (branch !== RIGHT && branch !== NONE) {
      if (step) {
        const action = BRANCH_OPTIONS[step.taskDefinitionId];
        if (action?.left?.class) {
          classKey = action.left.class;
        }
      }
    } else {
      classKey = 'no-node';
      if (step) {
        const action = BRANCH_OPTIONS[step.taskDefinitionId];
        if (action?.right?.class) {
          classKey = action.right.class;
        }
      }
    }
    return classKey;
  }

  static getBranchTextKey(step: WorkflowStepInterface, branch: Branch): [string, any] {
    let textKey = 'AUTOMATIONS.EDITOR.BRANCH.YES';
    if (typeof branch === 'number') {
      if (branch === NO_CONDITIONS_MET) {
        return ['AUTOMATIONS.EDITOR.BRANCH.NO', {}];
      }
      if (step) {
        const action = BRANCH_OPTIONS[step.taskDefinitionId];
        if (action?.left?.translationString) {
          if (action?.left?.translationString === USE_DYNAMIC_BRANCH_LABEL) {
            if (step.choices?.rules?.length > 1) {
              return ['AUTOMATIONS.EDITOR.BRANCH.BRANCH_NUMBER', { number: branch + 1 }];
            } else {
              textKey = 'AUTOMATIONS.EDITOR.BRANCH.YES';
            }
          } else {
            textKey = action.left.translationString;
          }
        }
      }
    } else {
      textKey = 'AUTOMATIONS.EDITOR.BRANCH.NO';
      if (step) {
        const action = BRANCH_OPTIONS[step.taskDefinitionId];
        if (action?.right?.translationString) {
          if (action?.right?.translationString === USE_DYNAMIC_BRANCH_LABEL) {
            if (step.choices?.rules?.length > 1) {
              textKey = 'AUTOMATIONS.EDITOR.BRANCH.NO_CONDITIONS_MET';
            } else {
              textKey = 'AUTOMATIONS.EDITOR.BRANCH.NO';
            }
          } else {
            textKey = action.right.translationString;
          }
        }
      }
    }
    return [textKey, {}];
  }
}
